var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-2030 -1052)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15_copy",
    "data-name": "Rectangle 15 copy",
    width: 50,
    height: 50,
    rx: 8,
    transform: "translate(2030 1052)",
    fill: "#5cc13e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "play-button-arrowhead",
    transform: "translate(2040.893 1068.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M10.8.364c-1.49-.855-2.7-.154-2.7,1.562V14.6c0,1.719,1.208,2.418,2.7,1.564L21.878,9.81c1.49-.855,1.49-2.24,0-3.094Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayVideo);
export default __webpack_public_path__ + "static/media/playVideo.1764072e6be32b379bd73a671d093972.svg";
export { ForwardRef as ReactComponent };